export const generateBookingEmail = (bookingData) => {
    // Basic validation
    if (!bookingData) return "";

    const {
        PackageTitle,
        TourBookID,
        CreatedOn, // Using this as a booking date
        TotalFare,
        DepartureDate,
        TotalBookedSeat,
        Customers,
        DestinationName
    } = bookingData;

    const contactPerson = Customers && Customers.length > 0
        ? (Customers.find(c => c.IsContact) || Customers[0]).CustomersTitle + ' ' + (Customers.find(c => c.IsContact) || Customers[0]).CustomersFirstName + ' ' + (Customers.find(c => c.IsContact) || Customers[0]).CustomersLastName
        : 'Customer';

    //const logoUrl = `${window.location.origin}/images/yatraTicketsLogo.jpg`;
    const logoUrl = 'https://www.yatratickets.com/images/yatraTicketsLogo.jpg';

    const formatMoney = (amount) => {
        return new Intl.NumberFormat('en-NP', { style: 'currency', currency: 'NPR' }).format(amount || 0);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toLocaleDateString("en-GB", {
            day: "numeric", month: "long", year: "numeric"
        });
    };

    return `
    <!DOCTYPE html>
    <html>
    <head>
        <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px; }
            .header { text-align: center; border-bottom: 1px solid #eee; padding-bottom: 20px; margin-bottom: 20px; }
            .logo { max-height: 80px; }
            .content { margin-bottom: 20px; }
            .booking-details { width: 100%; border-collapse: collapse; margin-top: 15px; }
            .booking-details th, .booking-details td { padding: 12px; border: 1px solid #eee; text-align: left; }
            .booking-details th { background-color: #f9f9f9; font-weight: bold; width: 40%; }
            .footer { text-align: center; font-size: 12px; color: #888; margin-top: 30px; border-top: 1px solid #eee; padding-top: 20px; }
            .success-text { color: #2e7d32; font-weight: bold; font-size: 18px; text-align: center; margin-bottom: 20px; }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <img src="${logoUrl}" alt="Yatra Ticket" class="logo" />
            </div>
            
            <div class="content">
                <div class="success-text">Booking Confirmation</div>
                
                <p>Dear ${contactPerson},</p>
                <p>Thank you for choosing Yatra Ticket! Your tour booking has been successfully confirmed. Below are the details of your booking:</p>
                
                <table class="booking-details">
                    <tr>
                        <th>Booking ID</th>
                        <td>${TourBookID || 'N/A'}</td>
                    </tr>
                    <tr>
                        <th>Package Name</th>
                        <td>${PackageTitle || 'N/A'}</td>
                    </tr>
                    <tr>
                        <th>Destination</th>
                        <td>${DestinationName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <th>Departure Date</th>
                        <td>${formatDate(DepartureDate)}</td>
                    </tr>
                    <tr>
                        <th>Booking Date</th>
                        <td>${formatDate(CreatedOn)}</td>
                    </tr>
                    <tr>
                        <th>Total Travelers</th>
                        <td>${TotalBookedSeat || 1}</td>
                    </tr>
                    <tr>
                        <th>Total Amount</th>
                        <td>${formatMoney(TotalFare)}</td>
                    </tr>
                </table>
                
                <p style="margin-top: 20px;">
                    We are excited to have you on this journey. If you have any questions or need to make changes, please contact our support team.
                </p>
            </div>
            
            <div class="footer">
                <p>&copy; ${new Date().getFullYear()} Yatra Ticket. All rights reserved.</p>
                <p>This is an automated email, please do not reply directly.</p>
            </div>
        </div>
    </body>
    </html>
    `;
};
